import React from 'react';
import PropTypes from 'prop-types';
import useLottie from '../../lib/hooks/useLottie';
import spinnerJson from './LoadingScreen/assets/bodymovin/loading_neutral.json';

const GenericSpinner = ({ style, ...props }) => {
  const [, lottieRef] = useLottie({
    animationData: spinnerJson,
    loop: true,
    autoplay: true,
  });

  const inlineStyle = {
    height: '576px',
    width: '1024px',
    ...style,
  };

  return (
    <div ref={lottieRef} style={inlineStyle} {...props} />
  );
};

GenericSpinner.propTypes = {
  style: PropTypes.object,
};

GenericSpinner.defaultProps = {
  style: {},
};

export default GenericSpinner;
